import { render, staticRenderFns } from "./componentMobileAppLink.vue?vue&type=template&id=21cccea7&scoped=true"
import script from "./componentMobileAppLink.vue?vue&type=script&lang=js"
export * from "./componentMobileAppLink.vue?vue&type=script&lang=js"
import style0 from "./componentMobileAppLink.vue?vue&type=style&index=0&id=21cccea7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cccea7",
  null
  
)

export default component.exports